module.exports = __webpack_public_path__ + "static/media/wireless-auditing.4528d2d6.png";